module.exports = __webpack_public_path__ + "static/media/classicos_feminino_beleza.40cb1c91.jpg";